import React from 'react';
import { useCurrentStateAndParams } from '../hooks';
export function Route(props) {
  const {
    state,
    component
  } = props;
  const current = useCurrentStateAndParams();
  if (!current.state.name) {
    return null;
  }
  if (current.state.name.includes(state)) {
    return /*#__PURE__*/React.createElement(component);
  }
  return null;
}
Route.displayName = 'Route';
//# sourceMappingURL=Route.js.map